import React from 'react';
import {
	RenewalData,
	withRenewalContext,
} from '../../../context/RenewalProvider';
import {
	BREADCRUMB__INVOICE,
	BREADCRUMB__INVOICES,
} from '../../../data/labelsAndMessages';
import { useRouteMatch } from '../../../util/useRouteMatch';
import BreadcrumbsContainer, { Breadcrumb } from '../../BreadcrumbsContainer';
import LargeCenterSpinner from '../../LargeCenterSpinner';
import {
	RenewalRoutes,
	ROUTES as RENEWAL_ROUTES,
} from '../Sidebar/RenewalSidebar';

interface Props {
	renewalData: RenewalData;
}

const Breadcrumbs = (props: Props) => {
	const { policy, renewalUpdateObj } = props.renewalData;

	const routeMatch = useRouteMatch(
		Object.keys(RENEWAL_ROUTES).map(
			(key) => RENEWAL_ROUTES[key as keyof RenewalRoutes],
		),
	);
	const params = routeMatch?.params;

	if (!policy) {
		return <LargeCenterSpinner />;
	}

	const { policyholderLocator, locator } = policy;

	const breadcrumbs: Breadcrumb[] = [
		{ href: `/policyholder/${policyholderLocator}`, text: 'Policyholder' },
		{ href: `/policy/${locator}`, text: `Policy ${locator}` },
		{
			href: `/policy/${locator}/renewals/${renewalUpdateObj.locator}`,
			text: `Renewal ${renewalUpdateObj.locator}`,
		},
	];

	// prepare invoices breadcrumbs
	if (
		[RENEWAL_ROUTES.INVOICE, RENEWAL_ROUTES.INVOICES].includes(
			routeMatch?.pattern?.path,
		)
	) {
		breadcrumbs.push({
			href: RENEWAL_ROUTES.INVOICES.replace(
				':policyId',
				policy.locator,
			).replace(':endorsementId', renewalUpdateObj.locator),
			text: BREADCRUMB__INVOICES(),
		});

		if (routeMatch?.pattern?.path === RENEWAL_ROUTES.INVOICE) {
			breadcrumbs.push({
				href: RENEWAL_ROUTES.INVOICE.replace(':policyId', policy.locator)
					.replace(':endorsementId', renewalUpdateObj.locator)
					.replace(':invoiceId', params.invoiceId),
				text: BREADCRUMB__INVOICE(params.invoiceId),
			});
		}
	}

	return <BreadcrumbsContainer breadcrumbs={breadcrumbs} />;
};

export default withRenewalContext<Props>(Breadcrumbs);
